import { Injectable } from '@angular/core'
import { AttachmentType } from 'src/app/interfaces/attachment-type'
import { ChatAnalysisType } from 'src/app/interfaces/chat-analysis/chat-analysis'
import { ChatAnalysisLogEvent } from 'src/app/interfaces/log/chat-analysis-log'
import { ShareMethod } from 'src/app/interfaces/share'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class ChatAnalysisLogService {
  constructor(private logService: LogService) { }

  // [채팅 분석 생성] 화면 진입
  logChatAnalysisCreateViewed(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_CREATE_VIEWED, { type })
  }
  // [채팅 분석 생성] 타입 상단 버튼 클릭
  logChatAnalysisCreateTypeClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_CREATE_TYPE_CLICKED, { type })
  }
  // [채팅 분석 생성] 파일 선택
  logChatAnalysisCreateFileSelected(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_CREATE_FILE_SELECTED, { type })
  }
  // [채팅 분석 생성] 분석하기 클릭
  logChatAnalysisCreateAnalyzeButtonClicked(type: ChatAnalysisType, isFree: boolean): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_CREATE_ANALYZE_BUTTON_CLICKED, { type, isFree })
  }
  // [채팅 분석 생성] 방법 확인하기 클릭
  logChatAnalysisCreateTutorialButtonClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_CREATE_TUTORIAL_BUTTON_CLICKED, { type })
  }
  // [채팅 분석 생성] 공유하기 클릭
  logChatAnalysisCreateShareClicked(type: ChatAnalysisType, shareType: ShareMethod): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_CREATE_SHARE_CLICKED, { type, shareType })
  }
  // [그룹 채팅 분석 로딩] 화면 진입
  logChatAnalysisLoadingViewed(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_LOADING_VIEWED, { type })
  }
  // [그룹 채팅 분석 본인 선택] 화면 진입
  logChatAnalysisSelfSelectViewed(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_SELF_SELECT_VIEWED, { type })
  }
  // [그룹 채팅 분석 본인 선택] 이름 클릭
  logChatAnalysisSelfSelectNameSelected(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_SELF_SELECT_NAME_SELECTED, { type })
  }
  // [그룹 채팅 분석 본인 선택] 선택 완료
  logChatAnalysisSelfSelectSubmit(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_SELF_SELECT_SUBMIT, { type })
  }
  // [그룹 채팅 분석 본인 선택] 찾을 수 없음 클릭
  logChatAnalysisResultNotFoundClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_RESULT_NOT_FOUND_CLICKED, { type })
  }
  // [그룹 채팅 분석 결과] 화면 진입
  logChatAnalysisResultViewed(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_RESULT_VIEWED, { type })
  }
  // [그룹 채팅 분석 결과] 이름 수정 버튼 클릭
  logChatAnalysisResultEditClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_RESULT_EDIT_CLICKED, { type })
  }
  // [그룹 채팅 분석 결과] 요약 클릭
  logChatAnalysisResultSummaryClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_RESULT_SUMMARY_CLICKED, { type })
  }
  // [그룹 채팅 분석 결과] 이름 클릭
  logChatAnalysisResultNameClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_RESULT_NAME_CLICKED, { type })
  }
  // [그룹 채팅 분석 결과] 공유하기 클릭
  logChatAnalysisResultShareClicked(type: ChatAnalysisType, shareType: ShareMethod): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_RESULT_SHARE_CLICKED, { type, shareType })
  }
  // [채팅 분석 리스트] 화면 진입
  logChatAnalysisListViewed(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_LIST_VIEWED, { type })
  }
  // [채팅 분석 리스트] 타입 상단 버튼 클릭
  logChatAnalysisListTypeClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_LIST_TYPE_CLICKED, { type })
  }
  // [채팅 분석 리스트] 새 분석 클릭
  logChatAnalysisListNewClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_LIST_NEW_CLICKED, { type })
  }
  // [채팅 분석 리스트] 아이템 클릭
  logChatAnalysisListItemClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_LIST_ITEM_CLICKED, { type })
  }
  // [채팅 분석 나를 찾을 수 없어요] 화면 진입
  logChatAnalysisNotFoundMeScreenViewed(isEmpty: boolean): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_NOT_FOUND_ME_SCREEN_VIEWED, { isEmpty })
  }
  // [채팅 분석 나를 찾을 수 없어요] 결과 버튼 클릭
  logChatAnalysisNotFoundMeResultButtonClicked(): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_NOT_FOUND_ME_RESULT_BUTTON_CLICKED)
  }
  // [채팅 분석 나를 찾을 수 없어요] 메인 버튼 클릭
  logChatAnalysisNotFoundMeMainButtonClicked(): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_NOT_FOUND_ME_MAIN_BUTTON_CLICKED)
  }
  // [채팅 분석 로딩] 광고 보기 클릭
  logChatAnalysisViewAdClicked(type: ChatAnalysisType, leftAdCount: number): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_VIEW_AD_CLICKED, { type, leftAdCount })
  }
  // [채팅 분석 로딩] 알림 켜기 클릭
  logChatAnalysisReceiveAlarmClicked(type: ChatAnalysisType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_RECEIVE_ALARM_CLICKED, { type })
  }
  logChatAnalysisAttachmentTypeDetailButtonClicked(type: AttachmentType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_ATTACHMENT_TYPE_DETAIL_BUTTON_CLICKED, { type })
  }
  logChatAnalysisAttachmentTypeDetailViewed(type: AttachmentType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_ATTACHMENT_TYPE_DETAIL_VIEWED, { type })
  }
  logChatAnalysisAttachmentTypeDetailShareClicked(type: AttachmentType): void {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_ATTACHMENT_TYPE_DETAIL_SHARE_CLICKED, { type })
  }
  //[채팅 분석 예시] 화면 진입
  logChatAnalysisExamplePageViewed(type: ChatAnalysisType) {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_EXAMPLE_PAGE_VIEWED, { type });
  }
  //[채팅 분석 생성] 예시 보기 버튼 클릭
  logChatAnalysisCreateExampleButtonClicked(type: ChatAnalysisType) {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_CREATE_EXAMPLE_BUTTON_CLICKED, { type });
  }
  //[채팅 분석 예시] 탭 버튼 클릭
  logChatAnalysisExampleTabClicked() {
    this.logService.eventLogging(ChatAnalysisLogEvent.CHAT_ANALYSIS_EXAMPLE_TAB_CLICKED);
  }
}
